import { SpeedDial, SpeedDialAction } from "@mui/material";
import ConstructionIcon from "@mui/icons-material/Construction";

import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import { EditSessionDialog } from "./EditSessionDialog";
import { useState } from "react";

export function LiveStreamingDebugControls() {
    const [showEditSessionDialog, setShowEditSessionDialog] = useState(false);

    const actions = [
        {
            icon: <HourglassEmptyIcon />,
            name: "Edit session",
            onClick: () => setShowEditSessionDialog(true),
        },
    ];

    return (
        <>
            <SpeedDial
                ariaLabel={"Debug controls"}
                sx={{
                    position: "absolute",
                    top: 80,
                    right: 16,
                }}
                icon={<ConstructionIcon />}
                direction="left"
            >
                {actions.map((action) => (
                    <SpeedDialAction
                        key={action.name}
                        icon={action.icon}
                        slotProps={{
                            tooltip: {
                                title: action.name,
                            },
                        }}
                        onClick={action.onClick}
                    />
                ))}
            </SpeedDial>
            {showEditSessionDialog && (
                <EditSessionDialog
                    closeDialog={() => setShowEditSessionDialog(false)}
                />
            )}
        </>
    );
}
